var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderTypePhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7767_32260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9769 4.06189L10.6647 8.06759H18.9592C17.8373 6.02327 15.5924 4.35426 12.9769 4.06189ZM5.61382 7.18674L7.92489 11.193L12.0721 4.00602C9.74152 3.95583 7.17461 5.06645 5.61382 7.18674ZM4.63693 15.1292L9.26013 15.1298L5.1129 7.94286C3.90425 9.93702 3.58197 12.7169 4.63693 15.1292ZM11.0231 19.9469L13.3352 15.9412H5.04082C6.16271 17.9856 8.40765 19.6545 11.0231 19.9469ZM18.3862 16.8221L16.0751 12.8159L11.9279 20.0028C14.2585 20.053 16.8254 18.9423 18.3862 16.8221ZM19.3631 8.87958L14.7399 8.87902L18.8871 16.066C20.0957 14.0718 20.418 11.2919 19.3631 8.87958Z",
    fill: "#12181E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7767_32260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderTypePhoto);
export default __webpack_public_path__ + "static/media/order_type_photo.be5a1e9cef75ea4187b3cdef0c0fd411.svg";
export { ForwardRef as ReactComponent };